import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Button, Offcanvas } from "react-bootstrap";
import { FaWhatsapp, FaPlane, FaShip, FaRocket, FaTimes } from "react-icons/fa";
import "./Inicio/Inicio.css";

import Navigation from "./Inicio/Navigation";
import HeroSection from "./Inicio/HeroSection";
import MetricsSection from "./Inicio/MetricsSection";
import HowItWorksSection from "./Inicio/HowItWorksSection";
import BenefitsSection from "./Inicio/BenefitsSection";
import PricingSection from "./Inicio/PricingSection";
import ParcelsSection from "./Inicio/ParcelsSection";
import TrackingSection from "./Inicio/TrackingSection";
import RepackagingSection from "./Inicio/RepackagingSection";
import CompraAsistidaSection from "./Inicio/CompraAsistidaSection";
import ContactSection from "./Inicio/ContactSection";
import Footer from "./Inicio/Footer";

const Inicio = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className='App' style={{ overflowX: "hidden" }}>
      <Helmet>
        <title>MBOX Express - Envíos de Miami a Honduras</title>
        <meta
          name='description'
          content='Somos tu mejor opción para traer tus compras internacionales de Miami a Honduras con el servicio más rápido y seguro.'
        />
        <meta
          name='keywords'
          content='MBOX,mbox, casillero en Miami, envíos a Honduras, paquetería internacional, transporte seguro de paquetes, MBOX Honduras'
        />
        <meta name='robots' content='index, follow' />
        <link rel='canonical' href='https://mbox-hn.com/' />
        <meta
          property='og:title'
          content='MBOX | Casillero en Miami para envíos a Honduras'
        />
        <meta
          property='og:description'
          content='Crea tu casillero en Miami con MBOX y envía tus paquetes de forma rápida y segura a Honduras.'
        />
        <meta property='og:type' content='website' />
        <meta property='og:url' content='https://mbox-hn.com' />
        <meta property='og:image' content='https://mbox-hn.com/og-image.jpg' />
        <meta name='twitter:card' content='summary_large_image' />
      </Helmet>

      <Navigation />
      <HeroSection />
      <MetricsSection />
      <HowItWorksSection />
      <BenefitsSection />
      <PricingSection />
      <ParcelsSection />
      <TrackingSection />
      <RepackagingSection />
      <CompraAsistidaSection />
      <ContactSection />
      <Footer />

      {/* Botón flotante WhatsApp y su Menú Lateral */}
      <Button
        variant='success'
        className='position-fixed rounded-circle d-flex align-items-center justify-content-center shadow-lg'
        style={{
          bottom: "30px",
          right: "30px",
          width: "60px",
          height: "60px",
          zIndex: 1000,
          transition: "transform 0.3s ease",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        onClick={handleShow}
      >
        <FaWhatsapp size={35} color='white' />
      </Button>

      <Offcanvas show={show} onHide={handleClose} placement='end'>
        <Offcanvas.Header
          className='bg-success text-white border-bottom'
          style={{ padding: "20px" }}
        >
          <div className='d-flex flex-column'>
            <Offcanvas.Title className='fs-4 fw-bold mb-1'>
              Atención al Cliente
            </Offcanvas.Title>
            <small className='text-white-50'>
              Selecciona el servicio que necesitas consultar
            </small>
          </div>
          <Button
            variant='link'
            className='text-white p-0 position-absolute top-0 end-0 mt-3 me-3'
            onClick={handleClose}
            style={{ opacity: 0.8 }}
          >
            <FaTimes size={24} />
          </Button>
        </Offcanvas.Header>

        <Offcanvas.Body className='p-4' style={{ backgroundColor: "#f8f9fa" }}>
          <div className='mb-4'>
            <h6 className='text-muted fw-bold mb-3 text-uppercase fs-7'>
              Servicios Disponibles
            </h6>
            <div className='d-flex flex-column gap-3'>
              <a
                href='https://wa.me/50498744314?text=Hola,%20me%20gustar%C3%ADa%20obtener%20informaci%C3%B3n%20sobre%20sus%20env%C3%ADos%20mar%C3%ADtimos.%20%C2%BFMe%20podr%C3%ADan%20ayudar%3F'
                target='_blank'
                rel='noopener noreferrer'
                className='text-decoration-none'
              >
                <div
                  className='d-flex align-items-center p-3 bg-white rounded-3 shadow-sm border border-success border-opacity-25 hover-effect'
                  style={{ transition: "all 0.2s ease" }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 12px rgba(25, 135, 84, 0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 .125rem .25rem rgba(0,0,0,.075)";
                  }}
                >
                  <div
                    className='bg-success bg-opacity-10 rounded-circle p-2 me-3 d-flex align-items-center justify-content-center'
                    style={{ width: "45px", height: "45px" }}
                  >
                    <FaShip className='text-success fs-4' />
                  </div>
                  <div>
                    <h6 className='text-dark mb-1 fw-bold'>Envío Marítimo</h6>
                    <small className='text-muted d-block'>
                      Para paquetes grandes o pesados
                    </small>
                  </div>
                </div>
              </a>

              <a
                href='https://wa.me/50498744314?text=Hola,%20me%20gustar%C3%ADa%20obtener%20informaci%C3%B3n%20sobre%20sus%20env%C3%ADos%20a%C3%A9reos.%20%C2%BFMe%20podr%C3%ADan%20ayudar%3F'
                target='_blank'
                rel='noopener noreferrer'
                className='text-decoration-none'
              >
                <div
                  className='d-flex align-items-center p-3 bg-white rounded-3 shadow-sm border border-success border-opacity-25 hover-effect'
                  style={{ transition: "all 0.2s ease" }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 12px rgba(25, 135, 84, 0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 .125rem .25rem rgba(0,0,0,.075)";
                  }}
                >
                  <div
                    className='bg-success bg-opacity-10 rounded-circle p-2 me-3 d-flex align-items-center justify-content-center'
                    style={{ width: "45px", height: "45px" }}
                  >
                    <FaPlane className='text-success fs-4' />
                  </div>
                  <div>
                    <h6 className='text-dark mb-1 fw-bold'>Envío Aéreo</h6>
                    <small className='text-muted d-block'>
                      Rápido y seguro para paquetes pequeños
                    </small>
                  </div>
                </div>
              </a>

              <a
                href='https://wa.me/50498744314?text=Hola,%20me%20gustar%C3%ADa%20obtener%20informaci%C3%B3n%20sobre%20sus%20env%C3%ADos%20express.%20%C2%BFMe%20podr%C3%ADan%20ayudar%3F'
                target='_blank'
                rel='noopener noreferrer'
                className='text-decoration-none'
              >
                <div
                  className='d-flex align-items-center p-3 bg-white rounded-3 shadow-sm border border-success border-opacity-25 hover-effect'
                  style={{ transition: "all 0.2s ease" }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 12px rgba(25, 135, 84, 0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 .125rem .25rem rgba(0,0,0,.075)";
                  }}
                >
                  <div
                    className='bg-success bg-opacity-10 rounded-circle p-2 me-3 d-flex align-items-center justify-content-center'
                    style={{ width: "45px", height: "45px" }}
                  >
                    <FaRocket className='text-success fs-4' />
                  </div>
                  <div>
                    <h6 className='text-dark mb-1 fw-bold'>Envío Express</h6>
                    <small className='text-muted d-block'>
                      La opción más rápida disponible
                    </small>
                  </div>
                </div>
              </a>
            </div>
          </div>

          <div
            className='mt-auto p-3 bg-success bg-opacity-10 rounded-3 border border-success border-opacity-25'
          >
            <div className='d-flex align-items-center mb-2'>
              <div
                className='bg-success rounded-circle me-2'
                style={{ width: "8px", height: "8px" }}
              ></div>
              <span className='fw-bold text-success' style={{ fontSize: "0.9rem" }}>
                En línea ahora
              </span>
            </div>
            <p className='mb-0 text-dark' style={{ fontSize: "0.85rem" }}>
              Nuestros agentes están listos para responder tus preguntas y
              ayudarte con tus envíos de lunes a viernes de 8:00 AM a 5:00 PM y
              sábados de 9:00 AM a 12:00 PM.
            </p>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default Inicio;
